export const SIDE_MENU_EXPANDED_WIDTH = "20%";
export const SIDE_MENU_COLLAPSED_WIDTH = "80px";
